<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('logs.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openLogForm"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetLogs(true)"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="logs"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openLogForm(props.item)">
								<td>{{ props.item.log_id }}</td>
								<td>{{ props.item.template_id }}</td>
								<td>{{ props.item.slug }}</td>
								<td>{{ props.item.frequency }}</td>
								<td>{{ props.item.minutes }}</td>
								<td>{{ props.item.capture }}</td>
								<td>{{ props.item.machine_id }}</td>
								<td>{{ props.item.part_id }}</td>
								<td>{{ props.item.supervisor_id }}</td>
								<td>{{ props.item.notes }}</td>
								<td>{{ props.item.file_id }}</td>
								<td>{{ props.item.version }}</td>
								<td>{{ props.item.active }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="logs"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="log_dialog">
                <v-card>
                    <v-form ref="form_log">
                        <v-card-title>
                            <span class="headline">{{ log.log_id ? $t('lang.edit_log') : $t('lang.add_log') }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeLogDialog"
                                :dialog-status="log_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
							<v-flex xs12>
								<v-text-field
									v-focus="log_dialog"
									v-model="log.log_id"
									:label="`${$t('lang.log_id')} *`"
									:counter="showCounter(log.log_id, 'logs.log_id')"
									:rules="ifValid('logs.log_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.template_id"
									:label="`${$t('lang.template_id')} *`"
									:items="user_functions_template"
									item-value="template_id"
									item-text="template_id"
									:rules="ifValid('logs.template_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.slug"
									:label="`${$t('lang.slug')} *`"
									:counter="showCounter(log.slug, 'logs.slug')"
									:rules="ifValid('logs.slug')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.frequency"
									:label="$t('lang.frequency')"
									:counter="showCounter(log.frequency, 'logs.frequency')"
									:rules="ifValid('logs.frequency')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.minutes"
									:label="$t('lang.minutes')"
									:counter="showCounter(log.minutes, 'logs.minutes')"
									:rules="ifValid('logs.minutes')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.capture"
									:label="$t('lang.capture')"
									:counter="showCounter(log.capture, 'logs.capture')"
									:rules="ifValid('logs.capture')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.machine_id"
									:label="$t('lang.machine_id')"
									:items="machines"
									item-value="machine_id"
									item-text="machine_id"
									:rules="ifValid('logs.machine_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.part_id"
									:label="$t('lang.part_id')"
									:items="parts"
									item-value="part_id"
									item-text="part_id"
									:rules="ifValid('logs.part_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.supervisor_id"
									:label="$t('lang.supervisor_id')"
									:counter="showCounter(log.supervisor_id, 'logs.supervisor_id')"
									:rules="ifValid('logs.supervisor_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="log.notes"
									:label="$t('lang.notes')"
									auto-grow
									rows="1"
									:rules="ifValid('logs.notes')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.file_id"
									:label="$t('lang.file_id')"
									:items="files"
									item-value="file_id"
									item-text="file_id"
									:rules="ifValid('logs.file_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.version"
									:label="`${$t('lang.version')} *`"
									:counter="showCounter(log.version, 'logs.version')"
									:rules="ifValid('logs.version')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="log.active"
									:label="`${$t('lang.active')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('logs.active')"
								></bc-select>
							</v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="log.log_id" color="error" @mouseup.left="$refs.delete_logs.openDialog()">{{ $t('lang.delete') }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeLogDialog()">{{$t('lang.cancel')}}</v-btn>
                            <v-btn color="success" @click="saveLogs">{{$t('lang.save')}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_logs"
                :heading="$t('lang.delete_log')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteLogs(log.log_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.add_new"), action: "openLogForm" }, { title: this.$t("lang.refresh"), action: "dbGetLogs", params: [true] }],
            headers: [
					{ text: this.$t('lang.log_id'), sortable: false, width: '7%' },
					{ text: this.$t('lang.template_id'), sortable: false, width: '7%' },
					{ text: this.$t('lang.slug'), sortable: false, width: '7%' },
					{ text: this.$t('lang.frequency'), sortable: false, width: '7%' },
					{ text: this.$t('lang.minutes'), sortable: false, width: '7%' },
					{ text: this.$t('lang.capture'), sortable: false, width: '7%' },
					{ text: this.$t('lang.machine_id'), sortable: false, width: '7%' },
					{ text: this.$t('lang.part_id'), sortable: false, width: '7%' },
					{ text: this.$t('lang.supervisor_id'), sortable: false, width: '7%' },
					{ text: this.$t('lang.notes'), sortable: false, width: '7%' },
					{ text: this.$t('lang.file_id'), sortable: false, width: '7%' },
					{ text: this.$t('lang.version'), sortable: false, width: '7%' },
					{ text: this.$t('lang.active'), sortable: false, width: '7%' }
            ],
            enableAddModal: true,
            enableEditModal: true,

            log: {},
            filter: {
                search: "",
                status: "1",


            },
            log_dialog: false,
            dbGetLogs: _.debounce(this.getLogs, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchLogs", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.logs) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchLogs({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.logs) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.logs.logs_filter,
            page: (state) => state.logs.page,
            rules_logs: (state) => state.logs.rules_logs,
            log_status_options: (state) => state.settings.log_status_options,
            logs: (state) => state.logs.logs,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchLogs", "saveLog", "deleteLog"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openLogForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_log) item ? this.$refs.form_log.resetValidation() : this.$refs.form_log.reset();

                    this.$nextTick(() => {
                        this.log = item != null ? this.assignObj2(item, this.rules_logs) : {};
                        this.log_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "log", params: { id: item.log_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_log) item ? this.$refs.form_log.resetValidation() : this.$refs.form_log.reset();
                    this.log_dialog = true;
                } else {
                    this.$router.push({ name: "log" });
                }
            }
        },
        saveLogs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_log")) {
                    let body = this.prepForm(this.log, this.rules_logs);

                    this.saveLog({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getLogs();
                                this.closeLogDialog();
                            } else {
                                this.$router.push({ name: "log", params: { id: data.log_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteLogs(id = null) {
            this.deleteLog({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getLogs();
                    this.closeLogDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeLogDialog() {
            this.log_dialog = false;
            this.$refs.delete_logs.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getLogs(pg_refresh = false) {
            this.startLoader();

            this.fetchLogs({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.log_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
};
</script>
